const generateKey = (clientId, namespace) => `${namespace}-${clientId}-token`;

const createStore = ({ clientId }) => {
  const namespace = 'st';
  const key = generateKey(clientId, namespace);

  const getToken = () => {
    if (typeof window === 'undefined') return null;
    const token = window.localStorage.getItem(key);
    if (token) {
      return JSON.parse(window.localStorage.getItem(key));
    }
    return token;
  };
  const setToken = (tokenData) => {
    if (typeof window === 'undefined') return;
    window.localStorage.setItem(key, JSON.stringify(tokenData));
  };
  const removeToken = () => {
    if (typeof window === 'undefined') return;
    window.localStorage.removeItem(key);
  };

  return {
    getToken,
    setToken,
    removeToken,
  };
};

export default createStore;
